// extracted by mini-css-extract-plugin
module.exports = {"container":"_1fZvXjcs","textContainer":"kf0cMWrL","active":"_3B8Jipdu"};